import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Detail as DetailComponent, InfoHeader, useRelationshipDiscoverer } from 'src/mtska-frontend-app-component';
import { useDataProvider } from 'src/mtska-frontend-data-provider';
import { AppContext } from 'src/mtska-frontend-app-scaffolding';
import { CircularProgress } from '@mui/joy';
import { Backdrop } from "@mui/material"

const dataProviderName = 'persons/person';
const model = 'persons/person';
const wizardName = 'Terminate employment';
const wizardObject = 'Employment';
const wizardAction = 'employmentDissociation';

const EmploymentDissociation = (params) => {
    const { t } = useTranslation();
    const { userCapabilities } = useContext(AppContext);

    const [drawable, setDrawable] = useState(true);
    const { doAction, item, errorMessage, errors, saving, success } = useDataProvider(dataProviderName, params.multipart);
    const { discover } = useRelationshipDiscoverer(params, item?.data, params?.detailStack?.inverseRelation, params?.detailStack?.stack);
    const [dissociated, setDissociated] = useState([])

    const handleCheckChange = (event) => {
        const checked = event.target.checked;
        const value = event.target.value;

        setDissociated((prev) => {
            if (checked) {
                return prev.includes(value) ? prev : [...prev, value];
            } else {
                return prev.filter((v) => v !== value);
            }
        });
    };

    const detailConfig = {
        "tabs": [
            {
                "name": "dissociation",
                "fieldsets": [
                    {
                        "name": "dissociation",
                        "fields": {
                            "employment_assigned": {
                                "type": "sectiontitle",
                                "className": "col-12"
                            },
                            "dissociated": {
                                "type": "relationship",
                                "view": "employment",
                                "readonly": true,
                                "checkable": true,
                                "checked": true,
                                "onCheckChange": handleCheckChange,
                                "relation": {
                                    "drawerRoutes": "employments",
                                    "inverseRelation": "person",
                                    "inverseRelationType": "relationship",
                                    "relationAssociator": "hidden",
                                    "relationDissociator": "hidden"
                                }
                            },
                        }
                    }
                ]
            }
        ],
        "validation": []
    }

    const [editing, setEditing] = useState(true)

    useEffect(() => {
        if (success) {
            (async () => {
                try {
                    await params.handleClose(params.uid, item.data)
                } catch (e) { }
            })()
        }
    }, [success]);

    const handleSave = async (data) => {
        data.dissociated = dissociated;
        doAction && doAction({ action: wizardAction, model: model ? model : dataProviderName, data: data });
    }

    const getDissociable = () => {
        let employments;
        if (params?.parent?.employments) {
            // arriva da X del biscotto
            employments = params?.parent?.employments;
        }
        if (params?.employments) {
            // arriva da menu
            employments = params.employments;
        }

        employments = employments.filter(employment => employment.status === 'active');
        employments = employments.map((employment) => {
            return { ...employment, person: { _id: item?.data?._id, firstname: item?.data?.firstname, lastname: item?.data?.lastname } }
        })

        return employments;
    }

    return (
        !drawable ? <Backdrop open={!drawable} style={{ backgroundColor: "white" }}><CircularProgress /></Backdrop> :
            <>
                <DetailComponent
                    values={{
                        "id": item?.data?._id,
                        "dissociated": getDissociable()
                    }}
                    modelName={model.split('/')[1]}
                    detailConfig={detailConfig}
                    dataProviderName={dataProviderName}
                    save={handleSave}
                    onEditing={setEditing}
                    saving={saving}
                    errors={errors}
                    errorMessage={errorMessage}
                    title={t(wizardName)}
                    canSave={userCapabilities && userCapabilities[dataProviderName + '.' + wizardAction.toLowerCase()]}
                    header={
                        <InfoHeader
                            view="wizard"
                            title={t(wizardName)}
                            subtitle={t('Terminate {{firstname}} {{lastname}} from the selected {{wizardObject}}', { wizardObject: wizardObject, firstname: item.data.firstname, lastname: item.data.lastname })}
                        />
                    }
                    {...params}
                />
            </>
    )
}

export default EmploymentDissociation;